import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=0febcd3c&scoped=true"
import script from "./Heatmap.vue?vue&type=script&lang=js"
export * from "./Heatmap.vue?vue&type=script&lang=js"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=0febcd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febcd3c",
  null
  
)

export default component.exports